/**
* 系统管理 系统环境变量
*/
<template>
	<div>
		<!-- 面包屑导航 -->
		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column prop="title" label="标题" width="200" align="center">
			</el-table-column>
			<el-table-column prop="room" label="活动地点" width="100" align="center">
			</el-table-column>
			<el-table-column prop="des" label="内容" width="300" align="center">
				<template slot-scope="scope">
					<div class="des-text">{{scope.row.des}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="timesi" label="时间" width="200" align="center">
				<template slot-scope="scope">
					<div class="des-text">{{scope.row.timesi[0]+'\n'+scope.row.timesi[1]}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="background" label="图片" width="200" align="center">
				<template slot-scope="scope">
					<img style="width: 100%; height: auto;" :src="imgh+'schooltheclassimg_' + scope.row.id + '_0.png'" />
				</template>
			</el-table-column>
			<el-table-column align="center" label="操作" width="200">
				<template slot-scope="scope">
					<el-button size="mini" type="danger" @click="deletePoster(scope.$index)">删除</el-button>
					<el-button size="mini" type="primary" @click="handleEdit(scope.$index)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-button type="primary" @click="handleEdit(-1)">添加活动</el-button>
		<!-- 编辑界面 -->
		<el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click='closeDialog("edit")'>
			<el-form label-width="80px" ref="editForm" :model="editForm" :rules="rules">
				<el-form-item label="标题" prop="title">
					<el-input size="small" v-model="editForm.title" auto-complete="off" placeholder="请输入活动标题" />
				</el-form-item>
				<el-form-item label="地点" prop="room">
					<el-input size="small" v-model="editForm.room" auto-complete="off" placeholder="请输入活动地点" />
				</el-form-item>
				<el-form-item label="内容" prop="des">
					<el-input size="small" type="textarea" v-model="editForm.des" placeholder="请输入活动介绍" />
				</el-form-item>
				<el-form-item label="活动时间" prop="times">
					<el-date-picker v-model="editForm.times" type="datetimerange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item v-if="theindex!=-1" label="详情图" prop="urls">
					<div class="main-block">
						<el-upload multiple action="#" :before-upload="(file) => {return beforeUpload_zhutu(file)}"
							accept=".png,.jpg,.gif" :multiple="true">
							<a :hidden="editForm.zimg.length!=0" class="iconfont icon-addimg add-img-icon" />
							<el-image class="main-img" v-for="iem in editForm.zimg" fit="contain" :src="iem.url"
								alt="" />
						</el-upload>
						<a class="iconfont icon-clean clean-img-icon" @click="deleteTheImg(0)" />
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click='closeDialog("edit")'>取消</el-button>
				<el-button size="small" type="primary" :loading="loading" class="title"
					@click="submitForm('editForm')">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { util } from 'cos-js-sdk-v5'
import {
		GetSchoolActiveList,
		SubmitTheSchoolActive,
		PictureServer,
		uploadFile,
		deleteImg,
		DeleteTheSchoolActive,
		formatTime
	} from '../../api/userMG'
	export default {
		data() {
			return {
				editFormVisible: false,
				loading: false, //是显示加载
				title: '添加',
				// 编辑与添加
				editForm: {
					des: '',
					title: '',
					zimg: [],
					room: '',
					times: []
				},
				// rules表单验证
				rules: {
					title: [{
						required: true,
						message: '请输入标题',
						trigger: 'blur'
					}],
					des: [{
						required: true,
						message: '请填写内容',
						trigger: 'blur'
					}],
					room: [{
						required: true,
						message: '请填写活动地点',
						trigger: 'blur'
					}],
					times: [{
						required: true,
						message: '请选择活动日期',
						trigger: 'blur'
					}]
				},
				listData: [], //用户数据
				imgh: PictureServer.Info
			}
		},
		created() {
			this.loading = true
			GetSchoolActiveList().then(res => {
				var img
				for (var i = 0; i < res.length; i++) {
					img = []
					for (var k = 0; k < res[i][7]; k++) {
						img.push({
							url: PictureServer.Info + 'schooltheclassimg_' + res[i][0] + '_' + k + '.png'+ '?rnd=' + Math.random()
						})
					}
					this.listData.unshift({
						id: res[i][0],
						title: res[i][1],
						des: res[i][2],
						room: res[i][3],
						timesi: [formatTime(new Date(res[i][4])),formatTime(new Date(res[i][5]))],
						times:[res[i][4],res[i][5]],
						state: res[i][6],
						img: img
					})
				}
				this.loading = false
			})
		},

		methods: {
			//显示编辑界面
			handleEdit: function(index) {
				if (index == -1) {
					this.title = '添加活动'
					this.editForm.title = ''
					this.editForm.des = ''
					this.editForm.zimg = []
					this.znums = 0
					this.editForm.room = ''
					this.editForm.times = null
				} else {
					this.title = '修改活动'
					this.editForm.title = this.listData[index].title
					this.editForm.des = this.listData[index].des
					this.editForm.zimg = this.listData[index].img
					this.editForm.room = this.listData[index].room
					this.editForm.times = [new Date(this.listData[index].times[0]), new Date(this.listData[index]
						.times[1])]
					this.znums = this.editForm.zimg.length
				}
				this.theindex = index
				this.editFormVisible = true
			},
			deletePoster(index) {
				this.$confirm('确定要删除吗?', '信息', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					DeleteTheSchoolActive(this.listData[index].id).then(res => {
						if (res) {
							this.$message({
								type: 'success',
								message: '已删除!'
							})
							this.listData.splice(index, 1)
							this.loading = false
						}
					})
				})
			},
			beforeUpload_zhutu(file) {
				var filen = 'schooltheclassimg_' + this.listData[this.theindex].id + '_' + this.znums + '.png'
				this.znums++
				setTimeout(r => {
					uploadFile(file, filen).then(res => {
						this.editForm.zimg.push({
							url: PictureServer.Info + filen + '?rnd=' + Math.random()
						})
					})
					return false;
				}, this.znums * 200)
			},
			deleteTheImg() {
				this.$confirm('确定删除图片吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					for (var k = 0; k < this.editForm.zimg.length; k++) {
						deleteImg('schooladimg_' + this.listData[this.theindex].id + '_' + k + '.png')
					}
					this.editForm.zimg = []
					this.znums = 0
					this.$message.success('该工作主图已全部删除');
				})
			},
			// 编辑、添加提交方法
			submitForm(editData) {
				this.$refs[editData].validate(valid => {
					if (valid) {
						if (this.theindex == -1) {
							var pa = {
								t: this.editForm.title,
								d: this.editForm.des,
								i: this.editForm.zimg.length,
								id: 0,
								s: this.editForm.times[0],
								e: this.editForm.times[1],
								r: this.editForm.room
							}
						} else {
							var pa = {
								t: this.editForm.title,
								d: this.editForm.des,
								i: this.editForm.zimg.length,
								id: this.listData[this.theindex].id,
								s: this.editForm.times[0],
								e: this.editForm.times[1],
								r: this.editForm.room
							}
						}
						SubmitTheSchoolActive(pa)
							.then(res => {
								this.loading = false
								if (res) {
									if (this.theindex == -1) {
										this.$message({
											type: 'success',
											message: '添加成功！'
										})
										this.listData.push({
											id: res,
											title: this.editForm.title,
											des: this.editForm.des,
											img: this.editForm.zimg,
											room: this.editForm.room,
											times: this.editForm.times,
											timesi: [formatTime(this.editForm.times[0]),formatTime(this.editForm.times[1])]
										})
									} else {
										this.$message({
											type: 'success',
											message: '数据保存成功！'
										})
										this.listData[this.theindex].title = this.editForm.title
										this.listData[this.theindex].des = this.editForm.des
										this.listData[this.theindex].img = this.editForm.zimg
										this.listData[this.theindex].room = this.editForm.room
										this.listData[this.theindex].times = this.editForm.times,
										this.listData[this.theindex].timesi= [formatTime(this.editForm.times[0]),formatTime(this.editForm.times[1])]
									}
									this.editFormVisible = false
								}
							})
					} else {
						return false
					}
				})
			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
			}
		}
	}
</script>

<style scoped>
	.main-block {
		width: 100%;
		height: 300px;
		border: 1px solid black;
		display: inline-block;
		overflow: auto;
	}

	.des-text {
		white-space: pre;
	}

	.main-img {
		max-height: 300px;
	}

	.clean-img-icon {
		float: right;
		margin: 0 10px 10px 0;
		font-size: 30px;
	}
</style>


// WEBPACK FOOTER //
// src/views/school/eventManagement.vue